var map = {
	"./apple-logo.svg": 58489,
	"./authentication-bg.png": 81454,
	"./authentication/authentication-bg.png": 47886,
	"./authentication/email-verification-img.jpg": 92063,
	"./authentication/email02.png": 35338,
	"./authentication/error-404.png": 90979,
	"./authentication/error-500.png": 34386,
	"./authentication/forget-img.png": 28600,
	"./authentication/forgot-02.png": 29339,
	"./authentication/forgot-password-img.jpg": 9928,
	"./authentication/login-bg.png": 24996,
	"./authentication/login-img.jpg": 42763,
	"./authentication/login.jpg": 46996,
	"./authentication/login02.png": 66370,
	"./authentication/register-img.jpg": 82857,
	"./authentication/register02.png": 5395,
	"./authentication/reset-password-img.jpg": 46017,
	"./authentication/reset02.png": 27570,
	"./authentication/step-two.png": 19521,
	"./authentication/under-maintenance.png": 7434,
	"./authentication/verify-img.png": 63674,
	"./avatar/New folder/avatar-18.jpg": 14814,
	"./avatar/avatar-1.jpg": 21356,
	"./avatar/avatar-10.jpg": 44721,
	"./avatar/avatar-11.jpg": 65092,
	"./avatar/avatar-12.jpg": 44997,
	"./avatar/avatar-13.jpg": 37245,
	"./avatar/avatar-14.jpg": 90094,
	"./avatar/avatar-14.png": 35817,
	"./avatar/avatar-15.jpg": 86443,
	"./avatar/avatar-15.png": 5210,
	"./avatar/avatar-16.jpg": 18619,
	"./avatar/avatar-16.png": 43547,
	"./avatar/avatar-17.jpg": 55854,
	"./avatar/avatar-18.jpg": 87645,
	"./avatar/avatar-2.jpg": 8476,
	"./avatar/avatar-3.jpg": 35172,
	"./avatar/avatar-4.jpg": 19820,
	"./avatar/avatar-5.jpg": 44983,
	"./avatar/avatar-6.jpg": 85140,
	"./avatar/avatar-7.jpg": 8436,
	"./avatar/avatar-8.jpg": 67116,
	"./avatar/avatar-9.jpg": 47155,
	"./avatar/group-01.png": 74462,
	"./avatar/group-02.png": 93638,
	"./barcode-01.png": 792,
	"./barcode-02.png": 75831,
	"./barcode-03.jpg": 88937,
	"./barcode/barcode-01.png": 4614,
	"./barcode/barcode-02.png": 27132,
	"./barcode/barcode-03.jpg": 94237,
	"./barcode/barcode1.png": 7395,
	"./barcode/qr-code.png": 78902,
	"./barcode1.png": 254,
	"./brand/adidas.jpg": 20534,
	"./brand/adidas.png": 67680,
	"./brand/brand-icon-01.png": 87300,
	"./brand/brand-icon-02.png": 44273,
	"./brand/brand-icon-03.png": 97355,
	"./brand/brand-icon-04.png": 89774,
	"./brand/brand-icon-05.png": 59701,
	"./brand/brand-icon-06.png": 70707,
	"./brand/brand-icon-07.png": 56800,
	"./brand/brand-icon-08.png": 42739,
	"./brand/brand-icon-09.png": 41062,
	"./brand/brand-icon-10.png": 20556,
	"./brand/colgate.png": 63361,
	"./brand/samsung.png": 63962,
	"./categories/category-01.png": 68554,
	"./categories/category-02.png": 61607,
	"./categories/category-03.png": 59550,
	"./categories/category-04.png": 83290,
	"./categories/category-05.png": 38239,
	"./categories/category-06.png": 99648,
	"./check-icon.svg": 77041,
	"./coming-soon.png": 93936,
	"./customer/customer1.jpg": 20004,
	"./customer/customer10.jpg": 26362,
	"./customer/customer2.jpg": 92461,
	"./customer/customer3.jpg": 66170,
	"./customer/customer4.jpg": 21106,
	"./customer/customer5.jpg": 9294,
	"./customer/customer6.jpg": 84559,
	"./customer/customer7.jpg": 24144,
	"./customer/customer8.jpg": 27651,
	"./customer/customer9.jpg": 16695,
	"./customer/no-imagecustomer.png": 2261,
	"./customer/people-customer-07.jpg": 27511,
	"./customer/profile.jpg": 14896,
	"./customer/profile2.jpg": 73251,
	"./customer/profile3.jpg": 24147,
	"./customer/profile4.jpg": 72461,
	"./customer/profile5.jpg": 25273,
	"./download-img.png": 50223,
	"./edit-supplier.jpg": 17045,
	"./email02.png": 64692,
	"./error-404.png": 15110,
	"./error-500.png": 33634,
	"./facebook-logo.svg": 76667,
	"./favicon.png": 24184,
	"./file-manager/folder-lg.png": 63242,
	"./file-manager/video1-.jpg": 91778,
	"./file-manager/video1.jpg": 79765,
	"./file-manager/video2.jpg": 83291,
	"./file-manager/video3.jpg": 73233,
	"./file-text-icon-01.svg": 14038,
	"./flags/ad.png": 2825,
	"./flags/ae.png": 7635,
	"./flags/af.png": 34664,
	"./flags/ag.png": 48118,
	"./flags/ai.png": 7658,
	"./flags/al.png": 15353,
	"./flags/am.png": 93941,
	"./flags/ao.png": 54255,
	"./flags/ar.png": 80115,
	"./flags/as.png": 99070,
	"./flags/at.png": 73632,
	"./flags/au.png": 57193,
	"./flags/aw.png": 58349,
	"./flags/ax.png": 5432,
	"./flags/az.png": 61318,
	"./flags/ba.png": 11732,
	"./flags/bb.png": 96333,
	"./flags/bd.png": 70857,
	"./flags/be.png": 6089,
	"./flags/bf.png": 94194,
	"./flags/bg.png": 44092,
	"./flags/bh.png": 65581,
	"./flags/bi.png": 17234,
	"./flags/bj.png": 70477,
	"./flags/bl.png": 50077,
	"./flags/bm.png": 20157,
	"./flags/bn.png": 11983,
	"./flags/bo.png": 15419,
	"./flags/bq.png": 4611,
	"./flags/br.png": 71720,
	"./flags/bs.png": 79246,
	"./flags/bt.png": 91391,
	"./flags/bv.png": 64680,
	"./flags/bw.png": 46167,
	"./flags/by.png": 70437,
	"./flags/bz.png": 51673,
	"./flags/ca.png": 23083,
	"./flags/cc.png": 75621,
	"./flags/cd.png": 4462,
	"./flags/cf.png": 20676,
	"./flags/cg.png": 53080,
	"./flags/ch.png": 72049,
	"./flags/ci.png": 47144,
	"./flags/ck.png": 68048,
	"./flags/cl.png": 85678,
	"./flags/cm.png": 87941,
	"./flags/cn.png": 62034,
	"./flags/co.png": 61946,
	"./flags/cr.png": 70243,
	"./flags/cu.png": 5374,
	"./flags/cv.png": 57282,
	"./flags/cw.png": 78878,
	"./flags/cx.png": 59532,
	"./flags/cy.png": 24493,
	"./flags/cz.png": 436,
	"./flags/de.png": 68165,
	"./flags/dj.png": 44669,
	"./flags/dk.png": 38377,
	"./flags/dm.png": 83929,
	"./flags/do.png": 22227,
	"./flags/dz.png": 4412,
	"./flags/ec.png": 58513,
	"./flags/ee.png": 47708,
	"./flags/eg.png": 16817,
	"./flags/er.png": 95823,
	"./flags/es.png": 14695,
	"./flags/et.png": 79051,
	"./flags/fi.png": 36101,
	"./flags/fj.png": 73325,
	"./flags/fk.png": 67631,
	"./flags/fm.png": 57653,
	"./flags/fo.png": 44441,
	"./flags/fr.png": 28823,
	"./flags/ga.png": 34172,
	"./flags/gb.png": 43068,
	"./flags/gd.png": 87814,
	"./flags/ge.png": 88180,
	"./flags/gf.png": 49146,
	"./flags/gg.png": 51062,
	"./flags/gh.png": 95863,
	"./flags/gi.png": 24177,
	"./flags/gl.png": 51893,
	"./flags/gm.png": 42780,
	"./flags/gn.png": 65657,
	"./flags/gp.png": 28403,
	"./flags/gq.png": 31307,
	"./flags/gr.png": 80501,
	"./flags/gs.png": 88471,
	"./flags/gt.png": 51043,
	"./flags/gu.png": 22893,
	"./flags/gw.png": 53470,
	"./flags/gy.png": 27763,
	"./flags/hk.png": 1825,
	"./flags/hn.png": 98081,
	"./flags/hr.png": 90005,
	"./flags/ht.png": 44523,
	"./flags/hu.png": 95269,
	"./flags/id.png": 82328,
	"./flags/ie.png": 45745,
	"./flags/il.png": 67338,
	"./flags/im.png": 12909,
	"./flags/in.png": 52080,
	"./flags/io.png": 82367,
	"./flags/iq.png": 43049,
	"./flags/ir.png": 17715,
	"./flags/is.png": 34401,
	"./flags/it.png": 61955,
	"./flags/je.png": 38536,
	"./flags/jm.png": 59424,
	"./flags/jo.png": 23147,
	"./flags/jp.png": 2615,
	"./flags/ke.png": 57885,
	"./flags/kg.png": 55214,
	"./flags/kh.png": 12822,
	"./flags/ki.png": 37006,
	"./flags/km.png": 63269,
	"./flags/kn.png": 22718,
	"./flags/kp.png": 21756,
	"./flags/kr.png": 7297,
	"./flags/kw.png": 8899,
	"./flags/ky.png": 43174,
	"./flags/kz.png": 67324,
	"./flags/la.png": 44305,
	"./flags/lb.png": 89973,
	"./flags/lc.png": 87591,
	"./flags/li.png": 28130,
	"./flags/lk.png": 16392,
	"./flags/lr.png": 47063,
	"./flags/ls.png": 33753,
	"./flags/lt.png": 70200,
	"./flags/lu.png": 76299,
	"./flags/lv.png": 59167,
	"./flags/ly.png": 52361,
	"./flags/ma.png": 16802,
	"./flags/mc.png": 71325,
	"./flags/md.png": 73351,
	"./flags/me.png": 76294,
	"./flags/mg.png": 74248,
	"./flags/mh.png": 73610,
	"./flags/mk.png": 6721,
	"./flags/ml.png": 26556,
	"./flags/mm.png": 14150,
	"./flags/mn.png": 60555,
	"./flags/mo.png": 83830,
	"./flags/mp.png": 17523,
	"./flags/mq.png": 13431,
	"./flags/mr.png": 73747,
	"./flags/ms.png": 66105,
	"./flags/mt.png": 72293,
	"./flags/mu.png": 15801,
	"./flags/mv.png": 68286,
	"./flags/mw.png": 47015,
	"./flags/mx.png": 90045,
	"./flags/my.png": 68418,
	"./flags/mz.png": 11138,
	"./flags/na.png": 77455,
	"./flags/nc.png": 93902,
	"./flags/ne.png": 3153,
	"./flags/nf.png": 57270,
	"./flags/ng.png": 2565,
	"./flags/ni.png": 27297,
	"./flags/nl.png": 28358,
	"./flags/no.png": 69022,
	"./flags/np.png": 7285,
	"./flags/nr.png": 37111,
	"./flags/nu.png": 94595,
	"./flags/nz.png": 17170,
	"./flags/om.png": 8203,
	"./flags/pa.png": 45290,
	"./flags/pe.png": 72214,
	"./flags/pf.png": 72751,
	"./flags/pg.png": 90929,
	"./flags/ph.png": 60467,
	"./flags/pk.png": 95474,
	"./flags/pl.png": 3435,
	"./flags/pm.png": 90509,
	"./flags/pn.png": 41330,
	"./flags/pr.png": 81198,
	"./flags/ps.png": 57394,
	"./flags/pt.png": 56488,
	"./flags/pw.png": 24057,
	"./flags/py.png": 42547,
	"./flags/qa.png": 85955,
	"./flags/re.png": 25521,
	"./flags/ro.png": 88214,
	"./flags/rs.png": 78786,
	"./flags/ru.png": 74355,
	"./flags/rw.png": 93258,
	"./flags/sa.png": 62390,
	"./flags/sb.png": 8749,
	"./flags/sc.png": 85155,
	"./flags/sd.png": 99799,
	"./flags/se.png": 5201,
	"./flags/sg.png": 93325,
	"./flags/sh.png": 28139,
	"./flags/si.png": 1364,
	"./flags/sk.png": 97482,
	"./flags/sl.png": 65126,
	"./flags/sm.png": 62221,
	"./flags/sn.png": 23501,
	"./flags/so.png": 50664,
	"./flags/sr.png": 52749,
	"./flags/ss.png": 34472,
	"./flags/st.png": 80725,
	"./flags/sv.png": 84402,
	"./flags/sx.png": 28513,
	"./flags/sy.png": 45037,
	"./flags/sz.png": 99226,
	"./flags/tc.png": 76903,
	"./flags/td.png": 61247,
	"./flags/tf.png": 68261,
	"./flags/tg.png": 64664,
	"./flags/th.png": 28973,
	"./flags/tj.png": 77639,
	"./flags/tk.png": 53817,
	"./flags/tl.png": 81533,
	"./flags/tm.png": 57916,
	"./flags/tn.png": 24267,
	"./flags/to.png": 38347,
	"./flags/tr.png": 29960,
	"./flags/tt.png": 74213,
	"./flags/tv.png": 56191,
	"./flags/tw.png": 37434,
	"./flags/tz.png": 27215,
	"./flags/ua.png": 5330,
	"./flags/ug.png": 28001,
	"./flags/um.png": 58259,
	"./flags/us.png": 14499,
	"./flags/us1.png": 45885,
	"./flags/uy.png": 1290,
	"./flags/uz.png": 18743,
	"./flags/va.png": 8442,
	"./flags/vc.png": 92094,
	"./flags/ve.png": 71204,
	"./flags/vg.png": 3653,
	"./flags/vi.png": 86544,
	"./flags/vn.png": 27448,
	"./flags/vu.png": 9380,
	"./flags/wf.png": 77970,
	"./flags/ws.png": 72051,
	"./flags/ye.png": 82336,
	"./flags/yt.png": 26221,
	"./flags/za.png": 82516,
	"./flags/zm.png": 93,
	"./flags/zw.png": 6920,
	"./forget-img.png": 82089,
	"./forrget02.png": 70333,
	"./hand01.svg": 53434,
	"./icon/audio.svg": 92933,
	"./icon/cash.svg": 80590,
	"./icon/credit-card.svg": 41166,
	"./icon/drag-drop.svg": 17014,
	"./icon/emoj-icon-01.svg": 81370,
	"./icon/emoj-icon-02.svg": 11727,
	"./icon/emoj-icon-03.svg": 42805,
	"./icon/emoj-icon-04.svg": 74011,
	"./icon/emoj-icon-05.svg": 94329,
	"./icon/emoji-smile.svg": 21862,
	"./icon/folder.svg": 60919,
	"./icon/half-circle.svg": 30162,
	"./icon/heart.svg": 87592,
	"./icon/image.svg": 15787,
	"./icon/like.svg": 61819,
	"./icon/pdf.svg": 18753,
	"./icon/play-01.svg": 22438,
	"./icon/qr-scan.svg": 16906,
	"./icon/smile-chat.svg": 62432,
	"./icon/trash-bin.svg": 1855,
	"./icon/video.svg": 7740,
	"./icon/xls.svg": 1357,
	"./icon/zip.svg": 20738,
	"./icons/Calculator.svg": 94564,
	"./icons/Macbook.svg": 19613,
	"./icons/Vector.svg": 91307,
	"./icons/add-circle.svg": 20197,
	"./icons/addprofile.svg": 97476,
	"./icons/airplay.svg": 14598,
	"./icons/app-icon-01.svg": 34064,
	"./icons/app-icon-02.svg": 17293,
	"./icons/app-icon-03.svg": 92010,
	"./icons/app-icon-04.svg": 99197,
	"./icons/app-icon-05.svg": 6138,
	"./icons/app-icon-06.svg": 2777,
	"./icons/app-icon-07.svg": 62797,
	"./icons/app-icon-08.svg": 33001,
	"./icons/app-icon-09.svg": 6800,
	"./icons/app-icon-10.svg": 91286,
	"./icons/apple-logo.svg": 7984,
	"./icons/arrow-left.svg": 69023,
	"./icons/audio.svg": 48983,
	"./icons/bar.svg": 86128,
	"./icons/bar1.svg": 1486,
	"./icons/bell.svg": 47137,
	"./icons/calendars.svg": 95091,
	"./icons/cash-pay.svg": 99538,
	"./icons/cash.svg": 18261,
	"./icons/check-icon.svg": 19626,
	"./icons/check.svg": 73028,
	"./icons/chevron-down.svg": 29116,
	"./icons/chevrons-left.svg": 97270,
	"./icons/close-circle.png": 44174,
	"./icons/close-circle.svg": 79097,
	"./icons/close-circle1.svg": 56531,
	"./icons/close-icon.svg": 12297,
	"./icons/closes.svg": 5755,
	"./icons/credit-card.svg": 43406,
	"./icons/dash1.svg": 7572,
	"./icons/dash2.svg": 73935,
	"./icons/dash3.svg": 40725,
	"./icons/dash4.svg": 54025,
	"./icons/dash5.svg": 50080,
	"./icons/dash6.svg": 59049,
	"./icons/dash7.svg": 20181,
	"./icons/dashboard.svg": 5662,
	"./icons/datepicker.svg": 88404,
	"./icons/debitcard.svg": 90383,
	"./icons/delete-2.svg": 3596,
	"./icons/delete.svg": 77054,
	"./icons/delete1.svg": 59173,
	"./icons/delete7.svg": 95453,
	"./icons/dollar-square.svg": 58315,
	"./icons/dollar.svg": 47029,
	"./icons/download.svg": 3221,
	"./icons/drag-drop.svg": 44420,
	"./icons/dropdown.svg": 63038,
	"./icons/edit-2.svg": 68955,
	"./icons/edit-5.svg": 43372,
	"./icons/edit-6.svg": 78088,
	"./icons/edit-set.svg": 23322,
	"./icons/edit.svg": 62365,
	"./icons/ellipise.svg": 25017,
	"./icons/ellipise1.svg": 18784,
	"./icons/emoj-icon-01.svg": 72369,
	"./icons/emoj-icon-02.svg": 53959,
	"./icons/emoj-icon-03.svg": 56827,
	"./icons/emoj-icon-04.svg": 45475,
	"./icons/emoj-icon-05.svg": 23703,
	"./icons/emoji-smile.svg": 32307,
	"./icons/envelope.svg": 77137,
	"./icons/excel.svg": 66074,
	"./icons/expense.svg": 72902,
	"./icons/expense1.svg": 58081,
	"./icons/eye.svg": 9947,
	"./icons/eye1.svg": 69173,
	"./icons/facebook-logo.svg": 51125,
	"./icons/facebook.png": 23852,
	"./icons/fb-icon.svg": 78938,
	"./icons/file-text-icon-01.svg": 65465,
	"./icons/filter.svg": 73232,
	"./icons/flag-01.svg": 66022,
	"./icons/flag-02.svg": 17252,
	"./icons/flag-03.svg": 67181,
	"./icons/flag-04.svg": 23160,
	"./icons/folder-minus.svg": 26928,
	"./icons/folder.svg": 39055,
	"./icons/fullscreen.svg": 73577,
	"./icons/gear.svg": 2559,
	"./icons/globe.svg": 11909,
	"./icons/google-icon.svg": 17012,
	"./icons/google.png": 34612,
	"./icons/half-circle.svg": 1386,
	"./icons/hand01.svg": 34946,
	"./icons/heart.svg": 57583,
	"./icons/hi.png": 49498,
	"./icons/hi.svg": 18045,
	"./icons/image.svg": 42703,
	"./icons/language.png": 95153,
	"./icons/life-buoy.svg": 70292,
	"./icons/like.svg": 33747,
	"./icons/linkedin-icon.svg": 25015,
	"./icons/loader.svg": 94760,
	"./icons/log-out.svg": 12586,
	"./icons/magnifier.svg": 86890,
	"./icons/mail.svg": 62711,
	"./icons/maximize.svg": 37869,
	"./icons/menu-icon-01.svg": 88981,
	"./icons/menu-icon-02.svg": 97722,
	"./icons/menu-icon-04.svg": 8540,
	"./icons/menu-icon-05.svg": 26027,
	"./icons/menu-icon-06.svg": 7225,
	"./icons/menu-icon.svg": 12455,
	"./icons/minus.svg": 68032,
	"./icons/notification-bing.svg": 78865,
	"./icons/pause.svg": 4315,
	"./icons/pause1.svg": 4682,
	"./icons/pay.svg": 85687,
	"./icons/payment-icon-01.svg": 26546,
	"./icons/payment-icon-02.svg": 59105,
	"./icons/payment-icon-03.svg": 70766,
	"./icons/payment-icon-04.svg": 43964,
	"./icons/payment-icon-05.svg": 14518,
	"./icons/payment-icon-06.svg": 32896,
	"./icons/payment-icon-07.svg": 10697,
	"./icons/payment-icon-08.svg": 72440,
	"./icons/payment-icon-09.svg": 80452,
	"./icons/payment-icon-10.svg": 80227,
	"./icons/payment-icon-11.svg": 17703,
	"./icons/payment-icon-12.svg": 52339,
	"./icons/payment-icon-13.svg": 27648,
	"./icons/payment-icon-14.svg": 65264,
	"./icons/payment-icon-15.svg": 53206,
	"./icons/payment-status.svg": 6541,
	"./icons/pdf-02.svg": 64313,
	"./icons/pdf.svg": 68370,
	"./icons/places.svg": 60859,
	"./icons/play-01.svg": 69054,
	"./icons/plus-circle.svg": 95796,
	"./icons/plus.svg": 94893,
	"./icons/plus1.svg": 4866,
	"./icons/plus11.svg": 10169,
	"./icons/plus12.svg": 96945,
	"./icons/power.svg": 18205,
	"./icons/printer.svg": 42230,
	"./icons/product.svg": 27881,
	"./icons/pur-invoice.svg": 14388,
	"./icons/purchase.svg": 11314,
	"./icons/purchase1.svg": 76682,
	"./icons/purchased-earnings.svg": 68359,
	"./icons/qr-scan.svg": 20575,
	"./icons/qrcode-scan.svg": 34540,
	"./icons/quotation1.svg": 72286,
	"./icons/razorpay.svg": 26953,
	"./icons/return1.svg": 66947,
	"./icons/reverse.svg": 88787,
	"./icons/right-arrow.svg": 54652,
	"./icons/sale.svg": 94703,
	"./icons/sales.svg": 29053,
	"./icons/sales1.svg": 6950,
	"./icons/salesinvoice.svg": 97609,
	"./icons/scan.svg": 73873,
	"./icons/scanner.svg": 45987,
	"./icons/scanner1.svg": 25134,
	"./icons/scanners.svg": 88258,
	"./icons/search-white.svg": 67919,
	"./icons/search-whites.svg": 79233,
	"./icons/search.svg": 77618,
	"./icons/settings.svg": 55895,
	"./icons/sidebar-delete-icon.svg": 22699,
	"./icons/sidebar-icon-01.svg": 875,
	"./icons/sidebar-icon-02.svg": 51715,
	"./icons/sidebar-icon-03.svg": 85093,
	"./icons/siderbar-icon1.svg": 83772,
	"./icons/siderbar-icon2.svg": 89619,
	"./icons/siderbar-icon3.svg": 39010,
	"./icons/smile-chat.svg": 61320,
	"./icons/sms-icon-01.svg": 24211,
	"./icons/sms-icon-02.svg": 54777,
	"./icons/sms-icon-03.svg": 62589,
	"./icons/storage-icon-01.svg": 48576,
	"./icons/storage-icon-02.svg": 99926,
	"./icons/stripe.svg": 20178,
	"./icons/sun-icon.svg": 98248,
	"./icons/time-big.svg": 3747,
	"./icons/time.svg": 73763,
	"./icons/total-sales.svg": 457,
	"./icons/transcation.svg": 34416,
	"./icons/transfer1.svg": 9925,
	"./icons/trash-bin.svg": 49617,
	"./icons/trash.svg": 3996,
	"./icons/trash12.svg": 86011,
	"./icons/twitter-icon.svg": 65884,
	"./icons/upload.svg": 68945,
	"./icons/user-icon.svg": 49465,
	"./icons/user.svg": 22676,
	"./icons/users.svg": 70840,
	"./icons/users1.svg": 89602,
	"./icons/video.svg": 91165,
	"./icons/voice.svg": 56164,
	"./icons/wallet.svg": 86668,
	"./icons/wallet1.svg": 2181,
	"./icons/weekly-earning.svg": 61030,
	"./icons/xls.svg": 79549,
	"./icons/zip.svg": 93753,
	"./img-01.jpg": 98438,
	"./img-02.jpg": 71921,
	"./img-03.jpg": 50794,
	"./img-04.jpg": 47522,
	"./img-05.jpg": 29967,
	"./img-1.jpg": 4463,
	"./img-2.jpg": 41824,
	"./img-3.jpg": 92964,
	"./img-4.jpg": 63305,
	"./img-5.jpg": 87064,
	"./join-call.jpg": 19128,
	"./join-call1.jpg": 7155,
	"./layout-01.png": 14477,
	"./layout-02.png": 74357,
	"./layout-03.png": 71178,
	"./layout-04.png": 86112,
	"./layout-ltr.png": 45816,
	"./layout-rtl.png": 36328,
	"./life-buoy.svg": 46079,
	"./login-bg.png": 87878,
	"./login-logo.png": 50957,
	"./login-user.png": 97086,
	"./login.jpg": 35468,
	"./login02.png": 36454,
	"./logo-small.png": 47623,
	"./logo-white.png": 7038,
	"./logo.png": 15080,
	"./media-link-01.jpg": 83808,
	"./media-link-02.jpg": 41804,
	"./media/media-01.jpg": 2014,
	"./media/media-02.jpg": 16022,
	"./media/media-03.jpg": 52327,
	"./media/media-04.jpg": 34863,
	"./media/media-05.jpg": 44624,
	"./media/media-35.jpg": 83465,
	"./media/media-36.jpg": 48163,
	"./media/media-6.jpg": 94618,
	"./media/media-link-01.jpg": 33513,
	"./media/media-link-02.jpg": 40670,
	"./new-icons/fb-icon.svg": 9970,
	"./new-icons/flag-01.svg": 14188,
	"./new-icons/flag-02.svg": 49950,
	"./new-icons/flag-03.svg": 73666,
	"./new-icons/flag-04.svg": 66042,
	"./new-icons/google-icon.svg": 12812,
	"./new-icons/linkedin-icon.svg": 75551,
	"./new-icons/pay.svg": 18356,
	"./new-icons/payment-icon-01.svg": 90756,
	"./new-icons/payment-icon-02.svg": 67385,
	"./new-icons/payment-icon-03.svg": 73742,
	"./new-icons/payment-icon-04.svg": 54926,
	"./new-icons/payment-icon-05.svg": 16844,
	"./new-icons/payment-icon-06.svg": 86010,
	"./new-icons/payment-icon-07.svg": 37966,
	"./new-icons/payment-icon-08.svg": 14389,
	"./new-icons/payment-icon-09.svg": 60365,
	"./new-icons/payment-icon-10.svg": 28672,
	"./new-icons/payment-icon-11.svg": 11239,
	"./new-icons/payment-icon-12.svg": 77481,
	"./new-icons/payment-icon-13.svg": 10344,
	"./new-icons/payment-icon-14.svg": 84699,
	"./new-icons/payment-icon-15.svg": 74338,
	"./new-icons/razorpay.svg": 60311,
	"./new-icons/sms-icon-01.svg": 88023,
	"./new-icons/sms-icon-02.svg": 88301,
	"./new-icons/sms-icon-03.svg": 208,
	"./new-icons/storage-icon-01.svg": 66306,
	"./new-icons/storage-icon-02.svg": 21248,
	"./new-icons/stripe.svg": 81744,
	"./new-icons/twitter-icon.svg": 94972,
	"./notes-profile/close-circle.png": 67334,
	"./notes-profile/people-profile.png": 74398,
	"./notes-profile/profile-01.png": 9784,
	"./notes-profile/profile-02.png": 63626,
	"./notes-profile/profile-03.png": 52371,
	"./people-customer/people-customer-07.jpg": 22365,
	"./people/supplier-01.png": 45213,
	"./people/supplier-02.png": 74246,
	"./people/supplier-03.png": 17583,
	"./people/supplier-04.png": 86506,
	"./people/supplier-05.png": 30613,
	"./people/supplier-06.png": 41905,
	"./people/supplier-07.png": 74666,
	"./people/supplier-08.png": 50173,
	"./people/supplier-09.png": 13698,
	"./people/supplier-10.png": 76080,
	"./phone-add-1.png": 27699,
	"./phone-add-2.png": 97447,
	"./print-receipt.png": 69882,
	"./product/Macbook.png": 65758,
	"./product/noimage.png": 87849,
	"./product/product1.jpg": 63442,
	"./product/product10.jpg": 24416,
	"./product/product11.jpg": 95777,
	"./product/product12.jpg": 43194,
	"./product/product13.jpg": 73938,
	"./product/product15.jpg": 45351,
	"./product/product17.jpg": 6809,
	"./product/product19.jpg": 16362,
	"./product/product2.jpg": 52513,
	"./product/product20.jpg": 29186,
	"./product/product21.jpg": 82834,
	"./product/product22.jpg": 20430,
	"./product/product23.jpg": 478,
	"./product/product24.jpg": 43730,
	"./product/product28.jpg": 46660,
	"./product/product29.jpg": 20307,
	"./product/product3.jpg": 85422,
	"./product/product30.jpg": 68113,
	"./product/product31.jpg": 55345,
	"./product/product32.jpg": 57961,
	"./product/product33.jpg": 66487,
	"./product/product34.jpg": 83174,
	"./product/product35.jpg": 83286,
	"./product/product36.jpg": 68334,
	"./product/product37.jpg": 32953,
	"./product/product4.jpg": 49417,
	"./product/product44.jpg": 9638,
	"./product/product45.jpg": 66800,
	"./product/product46.jpg": 80471,
	"./product/product47.jpg": 45661,
	"./product/product48.jpg": 19785,
	"./product/product48.png": 5846,
	"./product/product49.jpg": 86603,
	"./product/product5.jpg": 8809,
	"./product/product50.jpg": 51419,
	"./product/product51.jpg": 73954,
	"./product/product52.jpg": 26335,
	"./product/product53.jpg": 78483,
	"./product/product54.jpg": 20485,
	"./product/product55.jpg": 63921,
	"./product/product56.jpg": 11306,
	"./product/product57.jpg": 35592,
	"./product/product58.jpg": 6951,
	"./product/product59.jpg": 99690,
	"./product/product6.jpg": 11472,
	"./product/product60.jpg": 70141,
	"./product/product61.png": 42830,
	"./product/product62.png": 65055,
	"./product/product63.png": 38025,
	"./product/product64.png": 44794,
	"./product/product65.png": 35365,
	"./product/product66.png": 31475,
	"./product/product67.png": 95320,
	"./product/product68.png": 9464,
	"./product/product69.jpg": 38030,
	"./product/product7.jpg": 47478,
	"./product/product8.jpg": 41252,
	"./product/product9.jpg": 86023,
	"./products/expire-product-01.png": 10947,
	"./products/expire-product-02.png": 15760,
	"./products/expire-product-03.png": 89668,
	"./products/expire-product-04.png": 13078,
	"./products/phone-add-1.png": 27666,
	"./products/phone-add-2.png": 79315,
	"./products/pos-product-01.png": 63439,
	"./products/pos-product-02.png": 84924,
	"./products/pos-product-03.png": 64180,
	"./products/pos-product-04.png": 54722,
	"./products/pos-product-05.png": 88810,
	"./products/pos-product-06.png": 22721,
	"./products/pos-product-07.png": 55545,
	"./products/pos-product-08.png": 53538,
	"./products/pos-product-09.png": 36511,
	"./products/pos-product-10.png": 9977,
	"./products/pos-product-11.png": 1792,
	"./products/pos-product-12.png": 77317,
	"./products/pos-product-13.png": 28527,
	"./products/pos-product-14.png": 14255,
	"./products/pos-product-16.png": 52530,
	"./products/pos-product-17.png": 65270,
	"./products/pos-product-18.png": 59145,
	"./products/product-02.jpg": 52076,
	"./products/product1.jpg": 56554,
	"./products/product10.jpg": 76469,
	"./products/product11.jpg": 75589,
	"./products/product12.jpg": 33451,
	"./products/product13.jpg": 27245,
	"./products/product15.jpg": 38644,
	"./products/product17.jpg": 52348,
	"./products/product19.jpg": 90159,
	"./products/product2.jpg": 6762,
	"./products/product20.jpg": 22880,
	"./products/product21.jpg": 15727,
	"./products/product22.jpg": 85994,
	"./products/product23.jpg": 90425,
	"./products/product24.jpg": 84238,
	"./products/product28.jpg": 20842,
	"./products/product29.jpg": 64975,
	"./products/product3.jpg": 83017,
	"./products/product30.jpg": 92518,
	"./products/product31.jpg": 67622,
	"./products/product32.jpg": 76302,
	"./products/product33.jpg": 27080,
	"./products/product34.jpg": 27802,
	"./products/product35.jpg": 8881,
	"./products/product36.jpg": 56226,
	"./products/product37.jpg": 77599,
	"./products/product4.jpg": 95951,
	"./products/product44.jpg": 49238,
	"./products/product45.jpg": 82479,
	"./products/product46.jpg": 30997,
	"./products/product47.jpg": 78654,
	"./products/product48.png": 5305,
	"./products/product49.jpg": 91819,
	"./products/product5.jpg": 12137,
	"./products/product51.jpg": 77571,
	"./products/product52.jpg": 54883,
	"./products/product53.jpg": 83781,
	"./products/product54.jpg": 70578,
	"./products/product55.jpg": 28405,
	"./products/product56.jpg": 99541,
	"./products/product57.jpg": 45049,
	"./products/product58.jpg": 75204,
	"./products/product59.jpg": 19962,
	"./products/product6.jpg": 49241,
	"./products/product60.jpg": 16014,
	"./products/product61.png": 14274,
	"./products/product62.png": 83113,
	"./products/product63.png": 83967,
	"./products/product64.png": 96298,
	"./products/product65.png": 6871,
	"./products/product66.png": 64438,
	"./products/product67.png": 49046,
	"./products/product68.png": 14371,
	"./products/product69.jpg": 31117,
	"./products/product7.jpg": 23269,
	"./products/product8.jpg": 1859,
	"./products/product9.jpg": 8244,
	"./products/stock-img-01.png": 88757,
	"./products/stock-img-02.png": 46040,
	"./products/stock-img-03.png": 49800,
	"./products/stock-img-04.png": 60917,
	"./products/stock-img-05.png": 32574,
	"./products/stock-img-06.png": 47097,
	"./profiles/avatar-01.jpg": 80170,
	"./profiles/avatar-02.jpg": 40638,
	"./profiles/avatar-03.jpg": 26440,
	"./profiles/avatar-04.jpg": 51528,
	"./profiles/avatar-05.jpg": 81050,
	"./profiles/avatar-06.jpg": 9407,
	"./profiles/avatar-07.jpg": 33519,
	"./profiles/avatar-08.jpg": 97828,
	"./profiles/avatar-09.jpg": 77943,
	"./profiles/avatar-10.jpg": 7975,
	"./profiles/avatar-100.jpg": 8534,
	"./profiles/avatar-11.jpg": 46317,
	"./profiles/avatar-12.jpg": 68103,
	"./profiles/avatar-13.jpg": 69429,
	"./profiles/avatar-14.jpg": 17171,
	"./profiles/avatar-15.jpg": 22374,
	"./profiles/avatar-16.jpg": 17444,
	"./profiles/avatar-17.jpg": 57533,
	"./profiles/avatar-18.jpg": 17712,
	"./profiles/avatar-19.jpg": 58494,
	"./profiles/avatar-20.jpg": 48476,
	"./profiles/avatar-21.jpg": 83325,
	"./profiles/avatar-22.jpg": 38053,
	"./profiles/avatar-23.jpg": 42259,
	"./profiles/avatar-24.jpg": 76863,
	"./profiles/avatar-25.jpg": 89641,
	"./profiles/avatar-26.jpg": 36161,
	"./profiles/avatar-27.jpg": 15177,
	"./profiles/avatar-28.jpg": 82279,
	"./profiles/avatar-29.jpg": 37663,
	"./profiles/avatar-30.jpg": 49116,
	"./profiles/avator1.jpg": 26946,
	"./profiles/profile-01.png": 13420,
	"./profiles/profile-02.png": 67377,
	"./profiles/profile-03.png": 3175,
	"./profiles/profile.png": 88899,
	"./purchased-earnings.svg": 89792,
	"./qr-code.png": 71499,
	"./register02.png": 74093,
	"./reset02.png": 20517,
	"./sending-img.png": 85205,
	"./space-upgrade.jpg": 52433,
	"./step-two.png": 91265,
	"./store/store-01.png": 26233,
	"./store/store-02.png": 16339,
	"./store/store-03.png": 4279,
	"./store/store-04.png": 95735,
	"./supplier/edit-supplier.jpg": 96495,
	"./supplier/supplier-01.png": 10690,
	"./supplier/supplier-02.png": 73819,
	"./supplier/supplier-03.png": 74096,
	"./supplier/supplier-04.png": 43936,
	"./supplier/supplier-05.png": 39497,
	"./supplier/supplier-06.png": 57986,
	"./supplier/supplier-07.png": 73029,
	"./supplier/supplier-08.png": 71030,
	"./supplier/supplier-09.png": 89211,
	"./supplier/supplier-10.png": 83511,
	"./supplier/supplier1.png": 44916,
	"./supplier/supplier10.png": 25557,
	"./supplier/supplier2.png": 75694,
	"./supplier/supplier3.png": 72663,
	"./supplier/supplier4.png": 97093,
	"./supplier/supplier5.png": 43038,
	"./supplier/supplier6.png": 48075,
	"./supplier/supplier7.png": 44648,
	"./supplier/supplier8.png": 61302,
	"./supplier/supplier9.png": 78552,
	"./theme-img-01.jpg": 76222,
	"./theme-img-02.jpg": 35906,
	"./theme-img-03.jpg": 42453,
	"./theme/layout-01.png": 11254,
	"./theme/layout-02.png": 65313,
	"./theme/layout-03.png": 33174,
	"./theme/layout-04.png": 58165,
	"./theme/layout-ltr.png": 39481,
	"./theme/layout-rtl.png": 94956,
	"./theme/theme-img-01.jpg": 91354,
	"./theme/theme-img-02.jpg": 20221,
	"./theme/theme-img-03.jpg": 76047,
	"./theme/theme-img-04.jpg": 43537,
	"./theme/theme-img-05.jpg": 4351,
	"./theme/theme-img-06.jpg": 7487,
	"./theme/theme-img-07.jpg": 29809,
	"./theme/theme-img-08.jpg": 7343,
	"./theme/theme-img-09.jpg": 78681,
	"./theme/theme-img-10.jpg": 44772,
	"./time.svg": 22452,
	"./total-sales.svg": 71182,
	"./under-maintenance.png": 69800,
	"./user-5.jpg": 1279,
	"./user-6.jpg": 88958,
	"./user-7.jpg": 67039,
	"./user-icon.svg": 84878,
	"./users/edit-user.jpg": 75208,
	"./users/user-01.jpg": 45796,
	"./users/user-02.jpg": 66439,
	"./users/user-03.jpg": 76722,
	"./users/user-04.jpg": 93021,
	"./users/user-05.jpg": 61056,
	"./users/user-06.jpg": 82025,
	"./users/user-07.jpg": 32231,
	"./users/user-08.jpg": 85375,
	"./users/user-09.jpg": 81985,
	"./users/user-10.jpg": 18506,
	"./users/user-11.jpg": 9579,
	"./users/user-12.jpg": 26748,
	"./users/user-13.jpg": 48827,
	"./users/user-14.jpg": 97845,
	"./users/user-15.jpg": 22960,
	"./users/user-16.jpg": 16598,
	"./users/user-17.jpg": 72459,
	"./users/user-18.jpg": 26251,
	"./users/user-19.jpg": 56540,
	"./users/user-20.jpg": 26312,
	"./users/user-21.jpg": 91294,
	"./users/user-22.jpg": 71994,
	"./users/user-23.jpg": 52755,
	"./users/user-24.jpg": 53989,
	"./users/user-25.jpg": 9688,
	"./users/user-26.jpg": 41500,
	"./users/user-27.jpg": 99480,
	"./users/user-28.jpg": 82804,
	"./users/user-29.jpg": 17757,
	"./users/user-30.jpg": 71123,
	"./users/user-31.jpg": 83732,
	"./users/user-5.jpg": 45299,
	"./users/user-6.jpg": 87473,
	"./users/user-7.jpg": 87233,
	"./verify-img.png": 38664,
	"./voice.svg": 18547,
	"./weekly-earning.svg": 41731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;